<template>
  <v-card class="pa-4">
    <v-row>
      <v-col v-if="project.hyperlink">
        <label class="label">Link zewnętrzny:</label>
        <v-text-field
          :value="project.hyperlink"
          outlined
          dense
          readonly
          hide-details
        >
          <template #prepend-inner>
            <a
              :href="project.hyperlink"
              target="_blank"
            >
              <v-icon
                small
                class="hyperlink-icon"
              >
                mdi-open-in-new
              </v-icon>
            </a>
          </template>
        </v-text-field>
      </v-col>
      <v-col v-if="project.discLocation">
        <label class="label">Lokalizacja projektu:</label>
        <AppCopyUrl
          input-id="projectLocalization"
          :url="project.discLocation"
        />
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import AppCopyUrl from '@/components/UI/AppCopyUrl.vue';

export default {
  components: {
    AppCopyUrl,
  },

  props: {
    project: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.hyperlink-icon {
  margin-top: 7px;
  margin-right: 5px;
  color: #152E52
}
</style>
